<!--Navbar Padão-->
<nav>
  <!--Container do Logo-->
  <div class="nav-wrapper">
    <a class="brand-logo" type="button" routerLink="">
      <img src="./assets/logos/logo.svg" alt="Nutrientes Criativos" />
    </a>

    <!--Sidenav - Barra de menu mobile-->
    <a href="#" data-target="mobile-demo" class="sidenav-trigger"
      ><i class="material-icons">menu</i></a
    >

    <!--Conteúdo da barra de menu-->
    <ul class="right hide-on-med-and-down">
      <!-- <li><a routerLink="/linhas-de-pesquisa">Linhas de Pesquisa</a></li> -->
      <li><a routerLink="/projetos">Projetos</a></li>
      <li><a routerLink="/pesquisadores">Pesquisadores</a></li>
      <li><a routerLink="/events">Eventos</a></li>
      <li><a routerLink="/biblioteca">Biblioteca</a></li>
      <li><a routerLink="/contact">Comunicação</a></li>
      <a
        class="btn waves-effect waves-light green darken-3 text-white"
        routerLink="/login"
        >Cadastro</a
      >
    </ul>
  </div>
</nav>

<!--Sidenav-->
<ul class="sidenav" id="mobile-demo">
  <!--Navbar-toggle - Botão menu mobile-->
  <!-- <li><a routerLink="/linhas-de-pesquisa">Linhas de Pesquisa</a></li> -->
  <li><a routerLink="/projetos">Projetos</a></li>
  <li><a routerLink="/pesquisadores">Pesquisadores</a></li>
  <li><a routerLink="/events">Eventos</a></li>
  <li><a routerLink="/biblioteca">Biblioteca</a></li>
  <li><a routerLink="/contact">Comunicação</a></li>
  <a
    class="btn waves-effect waves-light green darken-3 text-white"
    routerLink="/login"
    >Cadastro</a
  >
</ul>
